import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../../components';
import { COLORS, device } from '../../../../constants';
import { TextParser } from '../../../../components/TextParser/TextParser';
import { Features } from '../../../../types/globalTypes';
import { SHADOW } from '../../../../constants/animations';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  feature: Features;
}

export const FeatureCard: React.FC<DivProps> = ({ feature }) => {
  return (
    <FeatureElement>
      <TextWrapper>
        <Text
          text={feature.Title}
          size={22}
          lineHeight={28}
          color={COLORS.RED_LINE}
        />
        <TextParser
          text={feature.Caption || ''}
          parseBy="-"
          textSize={18}
          textWeight={400}
          textColor={COLORS.BLACK}
          textElement={<Text />}
        />
      </TextWrapper>
    </FeatureElement>
  );
};

const FeatureElement = styled.div`
  box-sizing: border-box;
  background-color: ${COLORS.GRAY_BG_COLOR};
  padding: 20px;
  width: 100%;
  &:hover {
    box-shadow: ${SHADOW.HOVER.CARD_WITH_NUMBER};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  h4 {
    width: auto;
  }
  @media screen and ${device.sm} {
    h4 {
      min-height: auto;
      font-size: 14px;
      line-height: 19px;
    }
    div {
      max-width: none;
    }
  }

  @media screen and ${device.xs} {
    h4 {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;
